import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import type { UseFormReturn } from 'react-hook-form';
import type { EventPanelFormType, AttributeOption, CallForServiceOption } from '@mark43/cad-api';
import { useProQaMetadataStore } from '../../pro-qa/provider/pro-qa-metadata-provider';
import { useEventDraftProQaMetadataSync } from './hooks/use-event-draft-pro-qa-metadata-sync';

type Props = {
    eventId?: number;
    eventForm: UseFormReturn<EventPanelFormType>;
    eventPanelOptions?: {
        riskLevelOptions?: AttributeOption[];
        priorityOptions?: AttributeOption[];
    };
    callForServiceOptions?: CallForServiceOption[];
    currentProQaTempId?: string;
};

export const EventPanelFormProQaSync = observer(function EventPanelFormProQaSync({
    eventId,
    eventForm,
    eventPanelOptions,
    callForServiceOptions,
    currentProQaTempId,
}: Props): React.ReactElement | null {
    const proQaMetadataStore = useProQaMetadataStore();
    const eventDraftMetaData = proQaMetadataStore.proQaMetadata?.eventMetadata;
    const eventDraftProQaTempId = proQaMetadataStore.proQaMetadata?.tempEventId;

    // Cleared ProQA metadata on unmount to prevent stale data from being applied to a new draft.
    useEffect(() => {
        return () => {
            proQaMetadataStore.clearProQaMetadata();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEventDraftProQaMetadataSync({
        eventId,
        eventForm,
        eventPanelOptions,
        callForServiceOptions,
        eventDraftMetaData,
        currentProQaTempId,
        eventDraftProQaTempId,
    });

    return null;
});
